import PropTypes from 'prop-types';
import React from 'react';
import AdvertWrapper from 'modules/Common/components/AdvertWrapper';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import _ from 'lodash';

import { GOAL, OWNGOAL, PENALTY, SUBON, SUBOFF, YELLOWCARD, SECONDYELLOWCARD, REDCARD, FULLTIME, ENDOFFIRSTHALF } from 'modules/Football/consts';

import FootballMatchEventIcon from 'modules/Football/components/svg/FootballMatchEventIcon';

const eventTypeToIconMap = {
  [GOAL]: 'Goal',
  [OWNGOAL]: 'Goal',
  [PENALTY]: 'Penalty',
  [YELLOWCARD]: 'Yellow Card',
  [SECONDYELLOWCARD]: 'Second Yellow Card',
  [REDCARD]: 'Red Card',
  [SUBON]: 'Sub On',
  [SUBOFF]: 'Sub Off',
  [FULLTIME]: 'Full Time',
  [ENDOFFIRSTHALF]: 'Half Time'
};

export default function FootballMatchCommentary({events, matchLabel}){
  require('./FootballMatchCommentary.scss');
  // filter the events down to those that have commentary, in reverse order of event ID
  const commentary = _(events)
    .filter('event.comment')
    .sortBy(['match_sequence', 'match_event_reference.id'])
    .reverse()
    .value();

  const helmetProps = {
    title: `${matchLabel} - Commentary`
  };

  return (
    <div>
      {!_.isEmpty(commentary) ?
        <div>
          <MetaDataWrapper helmetProps={helmetProps}/>
          <ul className="commentary">
            {commentary.map(event =>
              <li className="event" key={event.match_event_reference.id}>
                <div className="time-col">
                  { !!event.match_time && <span className="match-time">{`${event.match_time}`}</span> }
                </div>
                <div className="type-col">
                  {event.event.event_type && <FootballMatchEventIcon type={eventTypeToIconMap[event.event.event_type.event_type] || ''}/>}
                </div>
                <div className="detail-col">
                  {event.event.comment}
                </div>
              </li>
            )}
          </ul>
        </div>
      :
        <div className="football-match-stats-none">
          <MetaDataWrapper helmetProps={helmetProps}/>
          No match commentary available.
        </div>}
      <AdvertWrapper ocSlot={["football", "leaderboard"]} additionalProperties={{view: "commentary"}} />
    </div>
  );
}

FootballMatchCommentary.propTypes = {
  match: PropTypes.object,
  matchLabel: PropTypes.string,
  events: PropTypes.object
};



// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchCommentary.js